import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { ImageUrl } from "../../../utils/constants";
import { CloseIconBranding } from "../../../utils/icons";
import {HeaderPopup, StyledModal, StyledModalBody, ScrollWrapper} from '../../HealthDataManagement/styles'
import {Theme} from '../styles'

class UpcomingThemes extends React.Component {

  render() {
    const { showModal, onClose, themesHeader } = this.props;
    const slicedArray =  themesHeader?.length >= 12 ?  themesHeader?.slice(0, 12) : themesHeader

    return (
      <StyledModal
        transform={1}
        show={showModal}
        newWidth={"432px"}
        newBg={"newBg"}
        height="50px"
        display="none"
        onHide={() => onClose()}
      >
        <HeaderPopup>
          <div className="title">Monthly Themes</div>
          <div className="closeIcon" onClick={() => onClose()}>
            {CloseIconBranding()}
          </div>
        </HeaderPopup>
        <div className="border-top"/>
        <StyledModalBody padding="16px 4px 16px 24px !important">
          <ScrollWrapper height={"380px"} scroll margin="0">
            {slicedArray?.map((item, index)=>
              (<Theme background={'transparent'} key={index} backgroundM="transparent" margin="0 24px 0 0">
                <div className='image'>
                  <img src={`${ImageUrl}/${item?.pillar_icon}`} />
                </div>
                <div className='wrap-theme'>
                  <div className='date'>{`${item.month} ${item.year}`}</div>
                  <div className='name'>{item.theme_text}</div>
                </div>
              </Theme>)
            )}
          </ScrollWrapper>
        </StyledModalBody>
      </StyledModal>
    );
  }
}

UpcomingThemes.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  history: PropTypes.object,
  themesHeader: PropTypes.array
};

const mapStateToProps = (state) => ({
  themesHeader: state.profileData.themesHeaderAll,
})

export default connect(mapStateToProps, null)(UpcomingThemes);
